import { render, staticRenderFns } from "./loaderWin.vue?vue&type=template&id=66618ff0&scoped=true&"
import script from "./loaderWin.vue?vue&type=script&lang=js&"
export * from "./loaderWin.vue?vue&type=script&lang=js&"
import style0 from "./loaderWin.vue?vue&type=style&index=0&id=66618ff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66618ff0",
  null
  
)

export default component.exports